<template>
  <div>
    <b-row class="justify-content-center" v-if="!loaded && loading">
      <b-spinner big label="Loading..."></b-spinner>
    </b-row>
    <h2 class="bordered-box-header" v-if="loaded">Informacje o koncie kursanta</h2>
    <b-container fluid class="bordered-box" v-if="loaded">
      <b-row>
        <p class="col-12">
          <span class="font-weight-bold">Email:</span>
          {{email}}
        </p>
        <p class="col-12">
          <span class="font-weight-bold">Email potwierdzony:</span>
          {{emailConfirmed ? "Tak" : "Nie"}}
        </p>

        <p class="col-12">
          <span class="font-weight-bold">Nr telefonu:</span>
          {{phoneNumber}}
        </p>

        <p class="col-12">
          <span class="font-weight-bold">Skype:</span>
          {{skype}}
        </p>
        <p class="col-12">
          <span class="font-weight-bold">Domyślna cena za makrocykl [PLN]:</span>
          {{parseFloat(monthlyPrice).toFixed(2) | replaceDotsWithCommas}}
        </p>
        <p class="col-12">
          <span class="font-weight-bold">Domyślna cena za makrocykl z samymi rozmowami [PLN]:</span>
          {{parseFloat(talksOnlyMonthlyPrice).toFixed(2) | replaceDotsWithCommas}}
        </p>
        <p class="col-12">
          <span class="font-weight-bold">Cena za lekcję [PLN]:</span>
          {{parseFloat(lessonPrice).toFixed(2) | replaceDotsWithCommas}}
        </p>
        <p class="col-12">
          <span class="font-weight-bold">Cena za rozmowę [PLN]:</span>
          {{parseFloat(talkPrice).toFixed(2) | replaceDotsWithCommas}}
        </p>
        <p class="col-12">
          <span class="font-weight-bold">Wolne środki prepaid [PLN]:</span>
          {{parseFloat(freePrepaidFunds).toFixed(2) | replaceDotsWithCommas}}
        </p>
        <p class="col-12">
          <span class="font-weight-bold">Zrealizowane / opłacone makrocykle:</span>
          {{generatedCycles}} / {{paidCycles}}
        </p>
        <p class="col-12">
          <span class="font-weight-bold">Opis:</span>
          {{description}}
        </p>
        <b-col cols="12">
          <button
            class="btn btn-success mr-2"
            @click="sendEmailConfirmation"
            v-if="!emailConfirmed"
          >
            <span v-show="!sendingEmail">Wyślij wiadomość do potwierdzenia adresu email</span>
            <span v-show="sendingEmail">
              <b-spinner small label="Proszę czekać..."></b-spinner>
            </span>
          </button>

          <button class="btn btn-primary edit-item" @click="showEditStudentModal">Edytuj</button>
        </b-col>
      </b-row>
    </b-container>
    <editStudentModal ref="editStudentModal" @save="onEditStudent" :student="student" />
  </div>
</template>

<script>
import { axios, eventBus } from "@/_infrastructure";
import editStudentModal from "./../EditStudentModal";

export default {
  data() {
    return {
      loading: false,
      sendingEmail: false,
      loaded: false,
      firstName: null,
      lastName: null,
      skype: null,
      description: null,
      phoneNumber: null,
      email: null,
      emailConfirmed: null,
      monthlyPrice: null,
      talksOnlyMonthlyPrice: null,
      talkPrice: null,
      lessonPrice: null,
      student: null,
      paidCycles: null,
      freePrepaidFunds: null,
      generatedCycles: null
    };
  },
  computed: {
    fullName() {
      return this.firstName + " " + this.lastName;
    }
  },
  props: ["id"],
  components: {
    editStudentModal
  },
  mounted() {
    if (this.id) {
      this.loading = true;

      axios
        .get("/students/details", {
          params: {
            id: this.id
          }
        })
        .then(response => {
          var result = response.data;
          this.loaded = true;

          this.student = result;

          this.firstName = result.firstName;
          this.lastName = result.lastName;
          this.skype = result.skype;
          this.description = result.description;
          this.email = result.email;
          this.emailConfirmed = result.emailConfirmed;
          this.paidCycles = result.paidCycles;
          this.generatedCycles = result.generatedCycles;
          this.phoneNumber = result.phoneNumber;
          this.monthlyPrice = result.monthlyPrice;
          this.talksOnlyMonthlyPrice = result.talksOnlyMonthlyPrice;
          this.talkPrice = result.talkPrice;
          this.lessonPrice = result.lessonPrice;
          this.freePrepaidFunds = result.freePrepaidFunds;
        })
        .catch(error => eventBus.$emit("unhandled-error", error))
        .then(() => {
          this.loading = false;
        });
    }
  },
  methods: {
    goto(url) {
      this.$router.push(url);
    },
    sendEmailConfirmation() {
      this.$bvModal
        .msgBoxConfirm(
          "Czy na pewno chcesz ponownie wysłać wiadomość z linkiem aktywacyjnym?"
        )
        .then(value => {
          if (value) {
            this.onSubmitSendEmailConfirmation();
          }
        });
    },
    onSubmitSendEmailConfirmation() {
      this.sendingEmail = true;
      axios
        .post("/auth/resendEmailConfirmation", {
          id: this.id
        })
        .then(() => {
          eventBus.$emit("notify-success", "Wysłano wiadomość");
        })
        .catch(error => eventBus.$emit("unhandled-error", error))
        .then(() => {
          this.sendingEmail = false;
        });
    },

    showEditStudentModal() {
      this.$refs.editStudentModal.show();
    },
    onEditStudent(r) {
      let self = this;

      let loader = this.$loading.show({
        container: this.$refs.mainContainer
      });

      axios["put"]("/students/edit", {
        id: self.id,
        phoneNumber: r.phoneNumber,
        skype: r.skype,
        description: r.description,
        monthlyPrice: r.monthlyPrice,
        talksOnlyMonthlyPrice: r.talksOnlyMonthlyPrice,
        talkPrice: r.talkPrice,
        lessonPrice: r.lessonPrice
      })
        .then(() => {
          self.phoneNumber = r.phoneNumber;
          self.skype = r.skype;
          self.description = r.description;
          self.monthlyPrice = r.monthlyPrice;
          self.talksOnlyMonthlyPrice = r.talksOnlyMonthlyPrice;
          self.talkPrice = r.talkPrice;
          self.lessonPrice = r.lessonPrice;

          self.student.skype = r.skype;
          self.student.phoneNumber = r.phoneNumber;
          self.student.description = r.description;
          self.student.monthlyPrice = r.monthlyPrice;
           self.student.talksOnlyMonthlyPrice = r.talksOnlyMonthlyPrice;
          self.student.talkPrice = r.talkPrice;
          self.student.lessonPrice = r.lessonPrice;

          eventBus.$emit("notify-success", "Zapisano poprawnie.");
        })
        .catch(error => eventBus.$emit("unhandled-error", error))
        .then(() => loader.hide());
    }
  }
};
</script>

<style lang="scss" scoped>
h2.bordered-box-header {
  margin-top: 20px;
  padding: 10px;
  margin-bottom: 0px;
  background: rgba(0, 0, 0, 0.03);
  border: 1px solid rgba(0, 0, 0, 0.125);
}

.bordered-box {
  border: 1px solid rgba(0, 0, 0, 0.125);
  padding: 10px;
}
</style>